export default "__VITE_ASSET__CSU5xrNQ__"